import { useMap } from "@vis.gl/react-google-maps";
import { memo, useEffect, useRef } from "react";
import { ARGENTINA_BOUNDS, locationsKey } from "./mapConstants";

const MapViewport = memo(function MapViewport({ locations }) {
  const map = useMap();
  const locationKey = locationsKey(locations);
  const fittedKeyRef = useRef(null);

  useEffect(() => {
    if (!map || fittedKeyRef.current === locationKey) return;
    fittedKeyRef.current = locationKey;

    if (locations.length === 0) {
      map.fitBounds(ARGENTINA_BOUNDS);
      return;
    }

    if (locations.length > 1) {
      const bounds = new google.maps.LatLngBounds();
      locations.forEach((location) => bounds.extend(location));
      map.fitBounds(bounds, 64);
      return;
    }

    map.setCenter(locations[0]);
    map.setZoom(14);
  }, [locationKey, locations, map]);

  return null;
});

export default MapViewport;
